<!-- 等级用户-列表首页 -->
<template>
  <div id="orgManage">
    <!-- 页面标题 -->
    <div class="title_page">用户组织管理</div>
    <!-- 头部标题&按钮 -->
    <div class="header flexBetween">
      <div class="opts_table"></div>
      <div class="opts_table">
        <!-- btns -->
        <elUploads :ifStaticTemplate="false" :uploadUrl="uploadUrl" :templateUrl="templateUrl" @success="getTableData"
          style="margin-right: 10px;">
          <el-button slot="upButton" type="info" plain size="small" icon="el-icon-upload">批量导入</el-button>
        </elUploads>
        <!-- 超级管理员可新增一级用户 -->
        <el-button v-if="common.isLogin() == -1" type="primary" size="small" icon="el-icon-folder-add"
          @click="$router.push({ path: '/accountPages/edit_org' })">新增一级用户</el-button>
        <!-- 模糊查询 -->
        <el-input placeholder="请输入内容" prefix-icon="el-icon-search" v-model="queryParam.keyWords" size="small" clearable
          @change="getTableData" @keyup.enter.native="getTableData" style="width: 180px"></el-input>
      </div>
    </div>
    <!-- 列表 -->
    <div class="table">
      <el-table :data="tableData" :cell-style="cellStyle" :header-cell-style="headerCellStyle" ref="table" row-key="id"
        :tree-props="{ children: 'userList' }" :expand-row-keys="expandedKeys" :key="orgTableKey" @row-click="rowClick">
        <el-table-column label="组织名称" width="220" show-overflow-tooltip>
          <template slot-scope="props">
            <span>{{ props.row.enterprieName }}</span>
          </template>
        </el-table-column>
        <el-table-column v-for="(item, i) in tableKeys_current" :key="`${i}I`" :prop="item.key" :label="item.title"
          :sortable="item.sortable ? 'custom' : false" show-overflow-tooltip :min-width="item.width ? item.width : ''"
          :align="item.align ?? 'center'">
          <template slot-scope="props">
            <div v-if="item.type == 'status'" :class="item.class_status ? item.class_status[props.row[item.key]] : ''">
              {{ item.text_status[props.row[item.key]] ? item.text_status[props.row[item.key]] : '--' }}
            </div>
            <div v-else-if="item.type == 'money'" class="nowrap">{{ `￥${common.formatNumber(props.row[item.key])}` }}
            </div>
            <div v-else-if="item.type == 'time'" class="nowrap">{{ props.row[item.key] ?
              moment(props.row[item.key]).format('YYYY-MM-DD') : '--' }}</div>
            <div v-else-if="item.key == 'selfNumber'" class="nowrap">{{ props.row[item.key] != null ? props.row[item.key]
              : '无限制' }}</div>
            <div v-else-if="item.key == 'expertNumber'" class="nowrap">{{ props.row[item.key] != null ?
              props.row[item.key] : '无限制' }}</div>

            <div v-else class="nowrap">{{ props.row[item.key] ? props.row[item.key] : '--' }}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="280" align="center">
          <template #default="scope">
            <el-button type="text" @click.stop="rowClick(scope.row)">详情</el-button>
            <el-button type="text" @click.stop="editRow(scope.row, 'edit')">编辑</el-button>
            <el-button v-if="common.isLogin() != scope.row.tier" type="text"
              @click.stop="delData(scope.row)">删除</el-button>
            <el-button type="text" @click.stop="editRow(scope.row, 'add')">新增子级</el-button>
            <el-button type="text" @click.stop="resetRow(scope.row, 'edit')">重置密码</el-button>
          </template>
        </el-table-column>
        <div slot="empty">
          <img src="../../../assets/img/emptyData.png" alt="" />
        </div>
      </el-table>
    </div>
    <!-- 分页 -->
    <div class="pagination">
      <div v-show="InnerWH.width > 450">共{{ total }}条数据</div>
      <el-pagination hide-on-single-page background @current-change="handleCurrentChange"
        :current-page.sync="queryParam.page" :page-size="10" :pager-count="5"
        :layout="InnerWH.width > 450 ? 'prev, pager, next, jumper' : 'prev, pager, next'" :total="total">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
import elUploads from '../../../components/elUploads.vue';
export default {
  name: 'salesContract',
  components: { elUploads },
  data() {
    return {
      moment: moment,
      templateUrl: 'https://www.casis.work:9000/template/用户导入模板.xlsx', //模板下载地址
      uploadUrl: `${process.env.BASE_URL}api/user/importUsers`, //上传地址
      // 列表查询传参
      queryParam: {
        keyWords: '',
        page: 1,
        limit: 10,
        tier: this.common.isLogin() == -1 ? '' : this.common.isLogin(),
        registerMail: this.currentUser && this.currentUser.registerMail && this.currentUser.registerMail != 'admin' ? this.currentUser.registerMail : '',
      },
      // 列表字段合集
      tableKeys_current: [
        { title: '目前所涉及的行业', key: 'category', width: 150 },
        { title: '子用户数量', key: 'sonCount', width: 150 },
        { title: '生成自评报告次数', key: 'selfNumber', type: 'selfNumber', width: 150 },
        { title: '生成报告次数', key: 'expertNumber', type: 'expertNumber', width: 150 },
        { title: '注册时间', key: 'createTime', type: 'time', width: 150 },
        { title: '企业法人', key: 'enterpriseLegalPerson', width: 150 },
        { title: '联系方式', key: 'enterpriseLegalPersonPhone', width: 150 },
      ],
      // 列表数据
      tableData: [],
      total: 0,
      expandedKeys: [],
      orgTableKey: '', //解决组织树重新渲染问题
    };
  },
  computed: {
    InnerWH: function () {
      return this.$store.getters.getInnerWH;
    },
    currentUser: function () {
      return this.$store.getters.getCurrentUser;
    },
  },
  mounted() {
    this.queryParam.registerMail = this.currentUser && this.currentUser.registerMail && this.currentUser.registerMail != 'admin' ? this.currentUser.registerMail : '';
    this.getTableData();
  },
  methods: {
    //组织列表
    async getTableData() {
      this.expandedKeys = [];
      this.orgTableKey = new Date().getTime();
      await this.$axios
        .post(`${process.env.BASE_URL}api/user/userOrganization`, this.queryParam)
        .then((res) => {
          if (res.data.code === 200) {
            this.tableData = Object.assign([], res.data.page.list);
            this.total = res.data.page.totalCount;
            if (this.tableData.length > 0) {
              this.tableData.forEach((e) => {
                if (e.userList && e.userList.length > 0) {
                  this.expandedKeys.push(e.id + '');
                }
              });
            }
          } else {
            this.$message({
              type: 'error',
              message: '查询失败-' + res.data.msg,
              offset: 80,
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 重置密码
    resetRow(row) {
      this.$msgbox({
        title: '重置密码',
        message: '是否确定重置该用户的密码？',
        showCancelButton: true,
        distinguishCancelAndClose: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        center: true,
        // cancelButtonClass: "cancelBtn cancelSetWidth",
        // confirmButtonClass: "uniteBtn",
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true;
            instance.confirmButtonText = '执行中...';
            let that = this;
            this.$axios
              .post(`${process.env.BASE_URL}api/login/passwordReset`, { id: row.id })
              .then((res) => {
                if (res.data.code == 200) {
                  that.$message.success('已重置密码');
                } else {
                  that.$message({
                    message: res.data.msg,
                    type: 'error',
                  });
                }
                //确认弹窗还原&关闭
                instance.confirmButtonText = '确定';
                instance.confirmButtonLoading = false;
                done();
              })
              .catch(() => {
                //确认弹窗还原&关闭
                instance.confirmButtonText = '确定';
                instance.confirmButtonLoading = false;
                done();
              });
          } else {
            //确认弹窗还原&关闭
            instance.confirmButtonText = '确定';
            instance.confirmButtonLoading = false;
            done();
          }
        },
      })
        .then((action) => { })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作',
            offset: 100,
          });
        });
    },
    // 详情
    rowClick(item) {
      this.$router.push({
        path: '/accountPages/detail_org',
        query: { id: item.id },
      });
    },
    // 列表-编辑
    editRow(row, type) {
      if (type == 'edit') {
        this.$router.push({
          path: '/accountPages/edit_org',
          query: { id: row.id, ifEdit: true, tier: row.tier },
        });
      } else {
        this.$router.push({
          path: '/accountPages/edit_org',
          query: { id: row.id, tier: row.tier, tierId: row.id, tierName: row.enterprieName },
        });
      }
    },
    // 列表-分页-变更当前页
    handleCurrentChange(val) {
      this.queryParam.page = val;
      this.getTableData();
    },
    // 删除
    delData(item) {
      this.$msgbox({
        title: '删除用户',
        message: '是否确定删除该用户及其下子用户？',
        showCancelButton: true,
        distinguishCancelAndClose: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        center: true,
        // cancelButtonClass: "cancelBtn cancelSetWidth",
        // confirmButtonClass: "uniteBtn",
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true;
            instance.confirmButtonText = '执行中...';
            let that = this;
            this.$axios
              .post(`${process.env.BASE_URL}api/user/deleteUser`, { id: item.id })
              .then((res) => {
                if (res.data.code == 200) {
                  let totalPage = Math.ceil((that.total - 1) / that.queryParam.limit);
                  let current = that.queryParam.page > totalPage ? totalPage : that.queryParam.page;
                  that.queryParam.page = current < 1 ? 1 : current;
                  that.getTableData();
                  that.$message({
                    message: '已删除',
                    type: 'success',
                  });
                } else {
                  that.$message({
                    message: res.data.msg,
                    type: 'error',
                  });
                }
                //确认弹窗还原&关闭
                instance.confirmButtonText = '确定';
                instance.confirmButtonLoading = false;
                done();
              })
              .catch(() => {
                //确认弹窗还原&关闭
                instance.confirmButtonText = '确定';
                instance.confirmButtonLoading = false;
                done();
              });
          } else {
            //确认弹窗还原&关闭
            instance.confirmButtonText = '确定';
            instance.confirmButtonLoading = false;
            done();
          }
        },
      })
        .then((action) => { })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作',
            offset: 100,
          });
        });
    },
    // 列表-表头样式
    headerCellStyle(header) {
      if (header.column.order == 'ascending' || header.column.order == 'descending') {
        return { color: '#3D7BDC', fontSize: '14px', fontWeight: 400 };
      } else {
        return { color: '#617180', fontSize: '14px', fontWeight: 400 };
      }
    },
    // 列表-单元格样式
    cellStyle() {
      return {
        fontSize: '14px',
        color: '#111928',
        fontWeight: 500,
        padding: '8px 0px',
      };
    },
  },
};
</script>
<style lang="less" scoped>
.opts_table {
  display: flex;
  align-items: center;
  margin-bottom: 10px;

  .el-select {
    width: 120px;
  }

  .el-select,
  .el-input {
    margin: 0px 5px;
    // min-width: 160px;
    // width: fit-content;
  }

  /deep/.el-select-dropdown__list {
    padding: 2px 0px 10px 0px;
  }

  /deep/.el-select-dropdown__item {
    font-size: 12px;
    height: 25px;
    line-height: 25px;
  }

  /deep/.el-scrollbar {
    overflow: auto;
    min-height: 100px;
  }
}

.btns_tab {
  width: 265px;
  display: flex;
  margin-top: 23px;
  margin-bottom: 17px;
  padding: 4px;
  font-weight: 500;
  border-radius: var(--rounded-md, 6px);
  border: 1px solid rgba(229, 231, 235, 0.8);
  background: var(--gray-100, #f3f4f6);

  div {
    width: 50%;
    text-align: center;
    cursor: pointer;
    line-height: 150%;
    padding: 4px;
  }

  .active {
    border-radius: var(--rounded-md, 6px);
    background: var(--gray-700, #374151);
    color: #ffffff;
  }
}
</style>
